import { logInvariant } from "./../_shared/log-invariant.js";
import { uuid } from "./../wix-rich-content-common/index.js";
const TOPICS = [
  "ricos.modals.functionality.modalOpened",
  "ricos.modals.functionality.modalClosed"
];
class ModalService {
  // eslint-disable-next-line no-useless-constructor
  constructor(modalSettings, state) {
    this.modalSettings = modalSettings;
    this.state = state;
    this.id = "ricos-modal-service";
    this.topicsToPublish = TOPICS;
    this.topicsToSubscribe = TOPICS;
  }
  openModal(config) {
    const modalSessionId = uuid();
    if (this.state.get()[config.id]) {
      console.warn(`Reopening modal ${config.id} that's already open`);
    }
    if (config.type === "exclusive") {
      const openModals = this.getOpenModals();
      openModals.forEach((openModal) => {
        if (openModal.id !== config.id) {
          this.closeModal(openModal.id);
        }
      });
    }
    const modal = {
      ...config,
      componentProps: { ...config.componentProps, modalSessionId }
    };
    this.state.set(
      (prev) => ({
        ...prev,
        [config.id]: modal
      })
    );
    this.publishers.byTopic("ricos.modals.functionality.modalOpened").publish({
      id: config.id,
      entryType: config.entryType,
      dropdownValue: config.dropdownValue,
      modalSessionId
    });
    this.modalSettings?.onModalOpen?.();
    return {
      patchProps: (newProps) => {
        this.state.set((prev) => {
          const modal2 = prev[config.id];
          if (!modal2) {
            logInvariant(new Error(`Patching modal with id ${config.id} which is not open`));
            return prev;
          }
          return {
            ...prev,
            [config.id]: {
              ...modal2,
              componentProps: { ...modal2.componentProps, ...newProps }
            }
          };
        });
      },
      close: () => this.closeModal(modal.id)
    };
  }
  togglePluginPanel({ isMobile, ...params }) {
    if (this.isModalOpen(params.id)) {
      this.closeModal(params.id);
      return;
    }
    this.openModal({
      enableDrag: !isMobile,
      dragHandleSelector: "[data-drag-handler]",
      layout: {
        desktop: params.positioning?.referenceElement ? "floating" : "dialog",
        mobile: params.mobileLayout ?? "fullscreen"
      },
      withTransition: !isMobile,
      type: "exclusive",
      disableArrowNavigation: true,
      onClickOutside: {
        on: "pointerup",
        handler: (e) => {
          if (params.focusReturnElement && !params.focusReturnElement?.contains(e.target)) {
            this.closeModal(params.id);
            return;
          }
          if (!params.positioning.referenceElement?.contains?.(e.target)) {
            this.closeModal(params.id);
            return;
          }
        }
      },
      ...params
    });
  }
  closeModal(modalId) {
    const modal = this.state.get()[modalId];
    if (!modal) {
      console.warn(`Fail to close modal: ${modalId} is not open`);
      return false;
    } else {
      this.state.set((prevState) => {
        const { [modalId]: _, ...remainingModals } = prevState;
        return remainingModals;
      });
      this.publishers.byTopic("ricos.modals.functionality.modalClosed").publish(modal);
      this.modalSettings?.onModalClose?.();
      return true;
    }
  }
  getOpenModals() {
    return Object.values(this.state.get());
  }
  isModalOpen(id) {
    const modal = this.state.get()[id];
    return !!modal;
  }
  onModalOpened(onOpen) {
    return this.subscriptors.byTopic("ricos.modals.functionality.modalOpened").subscribe((_topic, data) => {
      onOpen(data.id);
    });
  }
  onModalClosed(onClose) {
    return this.subscriptors.byTopic("ricos.modals.functionality.modalClosed").subscribe((_topic, data) => {
      onClose(data);
    });
  }
  getModal(id) {
    return this.state.get()[id];
  }
}
export {
  ModalService
};
//# sourceMappingURL=ModalService.js.map
